import Vue from "vue"
import VueRouter from "vue-router"
import login from './modules/security'
import parent from './modules/parent'
import admin from './modules/admin'
import { getToken } from '@/utils/auth'
import store from '@/store'
Vue.use(VueRouter)

export const routes = [
    {
        path:'/',redirect:"/parent/", component: () => import('@/layout/index'), children : [ 
           ...parent,
           ...admin,
        ]
    },
    ...login,
    { path: '*', component: () => import('@/views/404') }
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
})


function getAuthorityRoute(pathName){
  const re = /^(\/[^/]*)/g
  let path = pathName == '/' ?  '/parent' :  pathName
  if(path ==  '/parent' ) {
    store.dispatch('setAuthorityRoute',path)
  } else {
    if (re.exec(path) !== null && re.exec(path) !== undefined) {
      store.dispatch('setAuthorityRoute',re.exec(path)[0])
    }

  }
}

const whitelist = [
  `/admin/`,
  `/parent/`,
  `/parent/createAccount`,
  `/parent/forgetPassword`,
  `/parent/resendActivationCode`,
]
  
router.beforeEach((to, from, next) => {
    getAuthorityRoute(to.path)
    
    if (getToken(store.getters.authorityRoute)) {
      if (to.path === `${store.getters.authorityRoute}/`) {
        next()
      } 
      else {
        next()

      }
    } else {
      if (whitelist.includes(to.path) ) {
        next()

      } else {
        next({path: `${store.getters.authorityRoute}/`})
      }
      
    }
})

export default router